import type { SessionFeedbackAutomatedAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type AssociationDefinitions,
  type GroupBy,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryLimitToSQL,
  queryOrderToSQL,
} from './common'
import SessionQ from './SessionQ'

const SessionFeedbackAutomatedQ = {
  ...makeQueryModelV2<SessionFeedbackAutomatedAttributes>('session_feedback_automated')([
    'id',
    'session_id',
    'version',
    'statistics',
    'highlights',
    'feedback',
    'reflection',
    'metadata',
    'ready',
    'acknowledged_at',
    'created_at',
    'updated_at',
    'deleted_at',
  ]),

  associations: (): AssociationDefinitions => ({
    Session: {
      query: SessionQ,
      foreignKey: SessionQ.id,
      sourceKey: SessionFeedbackAutomatedQ.session_id,
    },
  }),

  where: (
    {
      sessionId,
      ready = null,
      acknowledged = null,
      paranoid = true,
      include = [],
      groupBy = null,
      order = null,
      limit = null,
    }: {
      sessionId?: number | null | SQLFragment<number>
      ready?: boolean | null
      acknowledged?: boolean | null
      paranoid?: boolean
      include?: IncludeAssociations
      groupBy?: GroupBy | null
      order?: QueryOrder | null
      limit?: number | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<SessionFeedbackAutomatedAttributes> => SQL`
        FROM ${SessionFeedbackAutomatedQ}
        ${includeAssociationsToSql(SessionFeedbackAutomatedQ, include)}
        WHERE
            ${
              sessionId != null
                ? SQL`${SessionFeedbackAutomatedQ.session_id} = ${sessionId} AND`
                : SQL``
            }
            ${
              ready != null
                ? SQL`${SessionFeedbackAutomatedQ.ready} IS ${ready ? SQL`TRUE` : SQL`FALSE`} AND`
                : SQL``
            }
            ${
              acknowledged != null
                ? SQL`${SessionFeedbackAutomatedQ.acknowledged_at} IS ${
                    acknowledged ? SQL`NOT NULL` : SQL`NULL`
                  } AND`
                : SQL``
            }
            ${paranoid ? SQL`${SessionFeedbackAutomatedQ.deleted_at} IS NULL AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
        ${queryLimitToSQL(limit)}
    `,

  hasGPTFeedback: (): SQLFragment<boolean> =>
    SQL`${SessionFeedbackAutomatedQ.feedback}->>'contents' IS NOT NULL`,
}

export default SessionFeedbackAutomatedQ
